import React, { useState, useEffect } from 'react';
import { Modal, Button } from 'react-bootstrap';
import EventBus from '../common/EventBus';

const GlobalErrorModal = () => {
    const [show, setShow] = useState(false);
    const [message, setMessage] = useState('');

    useEffect(() => {
        const formatErrorMessage = (value) => {
            if (value == null) {
                return "An unexpected error occurred.";
            }
            if (typeof value === 'string') {
                return value;
            }
            if (value instanceof Error) {
                return value.message || "An unexpected error occurred.";
            }
            if (typeof value === 'object') {
                if (typeof value.message === 'string') {
                    return value.error ? `${value.message} (${formatErrorMessage(value.error)})` : value.message;
                }
                if (value.message) {
                    return formatErrorMessage(value.message);
                }
                if (typeof value.error === 'string') {
                    return value.error;
                }
                if (value.error) {
                    return formatErrorMessage(value.error);
                }
                try {
                    return JSON.stringify(value);
                } catch (e) {
                    return "An unexpected error occurred.";
                }
            }
            return String(value);
        };

        // Listen for global showError events
        const handleErrorEvent = (errorMsg) => {
            setMessage(formatErrorMessage(errorMsg));
            setShow(true);
        };

        EventBus.on("showError", handleErrorEvent);
        EventBus.on("SHOW_ERROR_MODAL", handleErrorEvent);

        return () => {
            EventBus.remove("showError", handleErrorEvent);
            EventBus.remove("SHOW_ERROR_MODAL", handleErrorEvent);
        };
    }, []);

    const handleClose = () => {
        setShow(false);
        setMessage('');
    };

    return (
        <Modal show={show} onHide={handleClose} backdrop="static" keyboard={false}>
            <Modal.Header closeButton className="bg-danger text-white">
                <Modal.Title>Error</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="d-flex align-items-center">
                    <i className="bi bi-exclamation-triangle-fill text-danger me-3" style={{ fontSize: '2rem' }}></i>
                    <div>
                        <p className="mb-0" style={{ whiteSpace: 'pre-wrap' }}>{message}</p>
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    Close
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default GlobalErrorModal;
